import { invoke } from '@forge/bridge';

export type Field = {
    id: string;
    name: string;
    description?: string;
    schema?: {
        custom?: string;
    };
};

export type FieldConfiguration = {
    fieldContextId: string;
    id: string;
    _configuration?: any;
};

class FieldForgeApi {
    getFields(): Promise<Field[]> {
        return invoke('get-fields');
    }

    async getFieldConfiguration(fieldId: string, projectId?: string, issueTypeId?: string): Promise<FieldConfiguration> {
        return invoke('get-field-configuration', { fieldId, projectId, issueTypeId });
    }
}

export default new FieldForgeApi();
